import React from 'react';
import { Grid, GridProps, Box, BoxProps } from '@mui/material';

type ContainerVariant = 'lg' | 'md';

export type ContainerProps = {
  variant?: ContainerVariant;
  includesPageHeader?: boolean;
} & BoxProps;

const variantToMaxWidthMap = {
  lg: '1398px',
  md: '960px',
};

export const Container: React.FC<ContainerProps> = ({
  children,
  variant,
  includesPageHeader,
  ...restProps
}) => (
  <Box
    pt={includesPageHeader ? 0 : 3}
    pb={3}
    px={{ xs: 1, md: 4, xl: 8 }}
    mx='auto'
    boxSizing='content-box'
    maxWidth={variant ? variantToMaxWidthMap[variant] : variantToMaxWidthMap['lg']}
    {...restProps}
  >
    {children}
  </Box>
);

export const ContainerColumnsWrapper: React.FC<GridProps> = (props) => (
  <Grid spacing={1} {...props} container />
);

export const ContainerColumnLeft: React.FC<GridProps> = ({ children, ...restProps }) => {
  return (
    <Grid xs={12} lg={9} {...restProps} item>
      {children}
    </Grid>
  );
};

export const ContainerColumnRight: React.FC<GridProps> = ({ children, ...restProps }) => {
  return (
    <Grid xs={12} lg={3} {...restProps} item>
      {children}
    </Grid>
  );
};
